<template>
    <div v-loading.fullscreen.lock="loading">
        <shop-skin-dt-search-bar-component
            AddAuth="新增动态皮肤"
            :AllState="AllState"
            :AllType="AllType"
            @search="get_shop_skin_dt_index"
            @addTeam="addTeam"
        ></shop-skin-dt-search-bar-component>
        <el-descriptions
            direction="vertical"
            :column="8"
            :labelStyle="{'text-align':'center','background-color':'#e8edf2','width':'12.5%'}"
            :contentStyle="{'text-align': 'center','background-color':'#e8edf2'}"
            :colon="false"
            border
        >
            <el-descriptions-item v-for="item in res_data" :key="item.name">
                <template slot="label">
                    <span></span>
                </template> 
                <transition name="el-zoom-in-center">
                    <el-image
                        style="width: 100%;border-radius: 10px;"
                        :src="item['picture'].length > 0 ? item['picture'][0]['url'] : ''"
                        @click="details_shop_skin_dt(item.id)" 
                        v-show="transition_box"
                    >
                        <template slot="placeholder">
                            <img
                                style="width: 100%;border-radius: 10px;"
                                src="../../../assets/img/login_avatar.gif"
                            />
                        </template> 
                    </el-image>
                </transition>
                <div style="font-family: HarmonyOS_Sans_Black;" @click="details_shop_skin_dt(item.id)" >
                    <span v-if="item.type === 1">{{ item.name }}</span>
                    <span v-else-if="item.type === 2" style="color: #6cb4ff;">{{ item.name }}</span>
                    <span v-else-if="item.type === 3" style="color: #FF0000;">{{ item.name }}</span>
                </div>
            </el-descriptions-item>
            <el-descriptions-item v-for="i in res_buchong" :key="i+'bc'">
                <template slot="label">
                    <span></span>
                </template>
                <div style="width: 100%"></div>
            </el-descriptions-item>
        </el-descriptions>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="total"
            layout="total, prev, pager, next, jumper"
            @search="get_shop_skin_dt_index"
        ></common-page-component>
        <shop-skin-dt-edit-component
            edit_auth="修改动态皮肤"
            del_auth="删除动态皮肤"
            :id="fid"
            :show_type="edit_type"
            :dialogFormVisible="fdialogFormVisible"
            :shop_skin_dt_details_data="fshop_skin_dt_details_data"
            :AllState="AllState"
            :AllType="AllType"
            :UserItems="UserItems"
            :is_have_dynamic="is_have_dynamic"
            @exitShopSkinDtDialog="dialogExit"
            @search="get_shop_skin_dt_index"
            @show_edit="show_edit"
            @cancel_edit="cancel_edit"
            @details_row="details_shop_skin_dt"
            @RefreshItems="get_user_items_index()"
        ></shop-skin-dt-edit-component>
    </div>
</template>

<script>
import { ShopSkinDtIndexRequest,ShopSkinDtDetailsRequest } from '@/network/shop/ShopSkinDt.js'
import { UserItemsRequest } from '@/network/user.js'

import ShopSkinDtSearchBarComponent from '@/components/shop/ShopSkinDt/ShopSkinDtSearchBarComponent'
import ShopSkinDtEditComponent from '@/components/shop/ShopSkinDt/ShopSkinDtEditComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'

export default {
    name:'',
    data(){
        return {
            transition_box: false,
            fid: 0,
            edit_type: 0,
            fdialogFormVisible: false,
            loading: true,
            total: 0,
            cond: {
                state: 1,
                name: '',
                type: '',
                page: 1,
                limit: 16
            },
            res_data: [],
            res_buchong: 0,
            fshop_skin_dt_details_data: {},
            AllState:[
                {id:0,name:'下架'},
                {id:1,name:'正常'}
            ],
            AllType:[
                {id:1,name:'普通'},
                {id:2,name:'限定'},
                {id:3,name:'专属'}
            ],
            UserItems: {},
            is_have_dynamic: true
        }
    },
    computed:{},
    methods:{
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
        },
        show_edit() {
            this.edit_type = 2
        },
        cancel_edit() {
            this.edit_type = 0
        },
        get_shop_skin_dt_index(param = {}) {
            this.loading = true
            this.transition_box = false
            this.cond.state = param.state ?? this.cond.state
            this.cond.name = param.name ?? this.cond.name
            this.cond.type = param.type ?? this.cond.type
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }

            ShopSkinDtIndexRequest(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.res_data = s.result.data
                        this.total = s.result.total
                        const yushu = this.res_data.length % 8 === 0 ? 8 : this.res_data.length % 8
                        this.res_buchong = 8 - yushu
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
                .finally(() => this.transition_box = true)
        },
        details_shop_skin_dt(id) {
            this.fid = id
            this.fdialogFormVisible = true
            ShopSkinDtDetailsRequest(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.fshop_skin_dt_details_data = s.result.data
                        this.is_have_dynamic = s.result.is_have_dynamic
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
        },
        get_user_items_index() {
            UserItemsRequest()
                .then((s) => {
                    if (s.status === 0) {
                        this.UserItems = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        }
    },
    filters:{},
    props:{},
    created(){
        this.get_shop_skin_dt_index()
        this.get_user_items_index()
    },
    beforeDestroy(){},
    mounted(){},
    updated(){},
    components:{
        ShopSkinDtSearchBarComponent,
        ShopSkinDtEditComponent,
        CommonPageComponent
    },
    watch:{},
}
</script>

<style lang='less' scoped></style>